export default [
  {
    type: 'favicon',
    link: 'favicon.ico',
    requiresFileUpload: true
  },
  {
    type: 'background',
    link: 'background.png',
    requiresFileUpload: true
  },
  {
    type: 'fair_logo',
    link: 'logo.png',
    requiresFileUpload: true
  },
  {
    type: 'white_mail_logo',
    link: 'large_logo.png',
    requiresFileUpload: true
  },
  {
    type: 'privacy',
    requiresFileUpload: true,
    isHTML: true
  },
  {
    type: 'terms',
    requiresFileUpload: true,
    isHTML: true
  },
  {
    type: 'title',
    requiresFileUpload: false
  },
  {
    type: 'fair_name',
    requiresFileUpload: false
  },
  {
    type: 'mixpanel_key',
    requiresFileUpload: false
  },
  {
    type: 'adminvalidation',
    requiresFileUpload: false
  },
  {
    type: 'start_date',
    requiresFileUpload: false
  },
  {
    type: 'end_date',
    requiresFileUpload: false
  },
  {
    type: 'url',
    requiresFileUpload: false
  },
  {
    type: 'mail',
    requiresFileUpload: true,
    isHTML: true
  },
  {
    type: 'thank',
    requiresFileUpload: true,
    isHTML: true
  },
  {
    type: 'loader',
    link: 'loader.svg',
    requiresFileUpload: true,
  }
]